// animations.js

function animateUI() {
  const ribbon = document.querySelector(".ribbon");
  setTimeout(() => {
    ribbon.classList.add("show");
  }, 800);
}

function resetSectionAnimations() {
  document.querySelectorAll(
    "section .animate, section h1, section h2, sections h3, section p, section .word, .text, #map"
  ).forEach(el => {
    // Clear all animation-related styles
    el.style.opacity = "";
    el.style.transform = "";
    el.style.transition = "";
  });
}

// Animation utility functions
function animate(elements, properties, options = {}) {
  // Guard against empty element sets
  if (!elements || elements.length === 0) {
    console.warn("No elements to animate");
    return Promise.resolve();
  }
  
  if (!Array.isArray(elements)) {
    // Handle NodeList or single element
    elements = elements.length ? Array.from(elements) : [elements];
  }
  
  // Filter out null or undefined elements
  elements = elements.filter(el => el != null);
  
  if (elements.length === 0) {
    console.warn("No valid elements to animate after filtering");
    return Promise.resolve();
  }
  
  const {
    duration = 1,
    delay = 0,
    stagger = 0,
    ease = 'power2',
    onComplete = null
  } = options;
  
  // Easing functions
  const easingFunctions = {
    'power2': t => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2,
    'power4.Out': t => 1 - Math.pow(1 - t, 4),
    'power2.out': t => 1 - Math.pow(1 - t, 2),
    'power4': t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2,
    'back.out': t => {
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    }
  };
  
  // Get the easing function, default to linear if not found
  const easingFunction = easingFunctions[ease] || (t => t);
  
  return new Promise(resolve => {
    let completedCount = 0;
    
    elements.forEach((element, index) => {
      if (!element) {
        completedCount++;
        if (completedCount === elements.length) {
          if (onComplete) onComplete();
          resolve();
        }
        return;
      }
      
      const elementDelay = delay + (stagger * index);
      const startTime = performance.now() + elementDelay * 1000;
      const endTime = startTime + duration * 1000;
      
      // Store initial values
      const initialValues = {};
      const targetValues = {};
      
      for (const prop in properties) {
        if (prop === 'y') {
          const value = properties[prop];
          if (Array.isArray(value)) {
            initialValues[prop] = String(value[0]).replace('%', '') + (String(value[0]).includes('%') ? '%' : 'px');
            targetValues[prop] = String(value[1]).replace('%', '') + (String(value[1]).includes('%') ? '%' : 'px');
          } else {
            // If only target value provided
            const computedTransform = window.getComputedStyle(element).transform;
            let currentY = '0px';
            if (computedTransform !== 'none') {
              // Extract current Y if it exists
              const matrix = new DOMMatrix(computedTransform);
              currentY = `${matrix.m42}px`;
            }
            initialValues[prop] = currentY;
            targetValues[prop] = String(value).replace('%', '') + (String(value).includes('%') ? '%' : 'px');
          }
        } else if (prop === 'opacity') {
          if (Array.isArray(properties[prop])) {
            initialValues[prop] = properties[prop][0];
            targetValues[prop] = properties[prop][1];
          } else {
            initialValues[prop] = parseFloat(window.getComputedStyle(element).opacity);
            targetValues[prop] = properties[prop];
          }
        }
      }
      
      // Set initial values immediately for 'fromTo' animations
      for (const prop in initialValues) {
        if (prop === 'y') {
          element.style.transform = `translateY(${initialValues[prop]})`;
        } else if (prop === 'opacity') {
          element.style.opacity = initialValues[prop];
        }
      }
      
      // Create animation frame function
      function animateFrame() {
        const now = performance.now();
        
        // Haven't reached start time yet
        if (now < startTime) {
          requestAnimationFrame(animateFrame);
          return;
        }
        
        // Calculate progress
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / (duration * 1000), 1);
        const easedProgress = easingFunction(progress);
        
        // Apply current values
        for (const prop in targetValues) {
          if (prop === 'y') {
            const initialValue = parseFloat(initialValues[prop]);
            const targetValue = parseFloat(targetValues[prop]);
            const unit = targetValues[prop].includes('%') ? '%' : 'px';
            const currentY = initialValue + (targetValue - initialValue) * easedProgress;
            element.style.transform = `translateY(${currentY}${unit})`;
          } else if (prop === 'opacity') {
            const currentOpacity = initialValues[prop] + (targetValues[prop] - initialValues[prop]) * easedProgress;
            element.style.opacity = currentOpacity;
          }
        }
        
        // Continue animation if not complete
        if (progress < 1) {
          requestAnimationFrame(animateFrame);
        } else {
          completedCount++;
          if (completedCount === elements.length) {
            if (onComplete) onComplete();
            resolve();
          }
        }
      }
      
      requestAnimationFrame(animateFrame);
    });
  });
}

// Animation sequence manager (replace GSAP timeline)
class AnimationSequence {
  constructor() {
    this.animations = [];
    this.currentIndex = 0;
    this.isPlaying = false;
  }
  
  fromTo(elements, fromValues, toValues, options = {}) {
    const mergedProps = {};
    for (const key in fromValues) {
      mergedProps[key] = [fromValues[key], toValues[key]];
    }
    this.animations.push({ elements, properties: mergedProps, options });
    return this;
  }
  
  to(elements, properties, options = {}) {
    this.animations.push({ elements, properties, options });
    return this;
  }
  
  async play() {
    if (this.isPlaying) return this;
    
    this.isPlaying = true;
    for (let i = this.currentIndex; i < this.animations.length; i++) {
      const animation = this.animations[i];
      try {
        await animate(animation.elements, animation.properties, animation.options);
        this.currentIndex = i + 1;
      } catch (error) {
        console.error("Animation error:", error);
      }
    }
    this.isPlaying = false;
    this.currentIndex = 0;
    return this;
  }
}

// Create a timeline-like object
function createSequence() {
  return new AnimationSequence();
}

// Animate intro section
function animateIntro() {
  const introH1Words = document.querySelectorAll(".intro h1 .word");
  const introH2Words = document.querySelectorAll(".intro h2 .word");
  
  const allContentSections = document.querySelectorAll(".content");
    allContentSections.forEach(section => {
    // set opacity to 1
    section.style.opacity = '1';
  });
  
  // Verify elements exist before animating
  if (introH1Words.length === 0 && introH2Words.length === 0) {
    console.warn("No intro elements found to animate");
    return;
  }
  
  const introtl = createSequence();
  
  if (introH1Words.length > 0) {
    introtl.fromTo(
      introH1Words,
      { y: "115%" },
      { y: "0%" },
      { duration: 0.5, ease: 'power4.Out', stagger: 0.15, delay: 1 }
    );
  }
  
  if (introH2Words.length > 0) {
    introtl.fromTo(
      introH2Words,
      { y: "115%" },
      { y: "0%" },
      { duration: 0.5, ease: 'power4.Out', stagger: 0.05, delay: 0.5 }
    );
  }
  
  introtl.play();
  return introtl;
}

const sectionTimelines = {};
const splittingEasing = 'power4.Out';

function createSectionTimelines() {
  // Check if Splitting is available first
  if (typeof Splitting !== 'function') {
    console.warn("Splitting library not found. Text animations may not work correctly.");
  } else {
    // Apply Splitting
    const splittingTarget = document.querySelectorAll('h1, h2, h3');
    const splittingWords = Splitting({ target: splittingTarget, by: 'words' });
  }

  sectionTimelines["2010"] = () => {
    const elements = document.querySelectorAll(".y2010 h2 .word");
    if (elements.length === 0) return;
    
    const timeline = createSequence();
    timeline.fromTo(
      elements,
      { y: "115%" },
      { y: "0%" },
      { duration: 0.5, ease: splittingEasing, stagger: 0.15, delay: 0.5 }
    );
    timeline.play();
    return timeline;
  };

  sectionTimelines["2014"] = () => {
    const h1Words = document.querySelectorAll(".y2014 h1 .word");
    const h2Words = document.querySelectorAll(".y2014 h2 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };

  sectionTimelines["2017"] = () => {
    const h1Words = document.querySelectorAll(".y2017 h1 .word");
    const h2Words = document.querySelectorAll(".y2017 h2 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };

  sectionTimelines["2019"] = () => {
    const h1Words = document.querySelectorAll(".y2019 h1 .word");
    const h2Words = document.querySelectorAll(".y2019 h2 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };

  sectionTimelines["2022"] = () => {
    const h1Words = document.querySelectorAll(".y2022 h1 .word");
    const h2Words = document.querySelectorAll(".y2022 h2 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };

  sectionTimelines["2023"] = () => {
    const h1Words = document.querySelectorAll(".y2023 h1 .word");
    const h2Words = document.querySelectorAll(".y2023 h2 .word");
    const h3Words = document.querySelectorAll(".y2023 h3 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h3Words.length > 0) {
      timeline.to(h3Words, { opacity: 1 }, { duration: 0.5, stagger: 0.03, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };

  sectionTimelines["2024"] = () => {
    const h1Words = document.querySelectorAll(".y2024 h1 .word");
    const h2Words = document.querySelectorAll(".y2024 h2 .word");
    
    const timeline = createSequence();
    if (h1Words.length > 0) {
      timeline.to(h1Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    if (h2Words.length > 0) {
      timeline.to(h2Words, { y: 0 }, { duration: 0.5, ease: splittingEasing });
    }
    timeline.play();
    return timeline;
  };
}

// Animate outro section
function animateOutro() {
  const outroH2Words = document.querySelectorAll(".outro h2 .word");
  const outroText = document.querySelectorAll(".outro .text");
  const outroLinks = document.querySelectorAll(".outro a");
  const map = document.querySelectorAll('#map');
  
  const outrotl = createSequence();
  
  if (outroH2Words.length > 0) {
    outrotl.fromTo(
      outroH2Words,
      { y: "115%" },
      { y: "0%" },
      { duration: 0.5, ease: splittingEasing, stagger: 0.15, delay: 1 }
    );
  }
  
  if (outroText.length > 0) {
    outrotl.fromTo(
      outroText,
      { opacity: 0 },
      { opacity: 1 },
      { duration: 1, stagger: 0.05 }
    );
  }
  
  if (outroLinks.length > 0) {
    outrotl.fromTo(
      outroLinks,
      { opacity: 0 },
      { opacity: 1 },
      { duration: 1, stagger: 0.05 }
    );
  }
  
  if (map.length > 0) {
    outrotl.fromTo(
      map,
      { opacity: 1 },
      { opacity: 0.2 },
      { duration: 1 }
    );
  }
    
  outrotl.play();
  return outrotl;
}

// Animate section by year (hooked from observer)
function animateSectionByYear(year) {
  if (sectionTimelines[year]) {
    sectionTimelines[year]();
  } else {
    console.warn(`No animation timeline defined for year ${year}`);
  }
  
  // Animate polaroids if they exist for this section
  const section = document.querySelector(`.y${year}`);
  const otherSections = document.querySelectorAll('section:not(.y' + year + ')');

   // Check if polaroids.js is loaded
  if (typeof window.hidePolaroids !== 'function') {
    console.error('Polaroids functionality not loaded. Please ensure polaroids.js is included.');
    return;
  }

  // Hide polaroids in other sections with proper error handling
  if (typeof hidePolaroids === 'function' && otherSections?.length > 0) {
    try {
      otherSections.forEach(section => {
        // Only process sections that actually have polaroids
        if (section?.querySelector('.polaroid')) {
          hidePolaroids(section);
        }
      });
    } catch (error) {
      console.warn('Error hiding polaroids:', error);
    }
  }


  if (section && section.querySelector('.polaroids')) {
    // Add a small delay to let text animations start first
    setTimeout(() => {
      if (typeof animatePolaroids === 'function') {
        animatePolaroids(section);
      }
    }, 500);
  }

}

// Make everything globally available
window.animateUI = animateUI;
window.createSectionTimelines = createSectionTimelines;
window.animateIntro = animateIntro;
window.animateOutro = animateOutro;
window.animateSectionByYear = animateSectionByYear;
window.resetSectionAnimations = resetSectionAnimations;